import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import FontAbhaya from "../../AbhayaLibre-SemiBold.ttf";
import RobotoBold from "../../Roboto-Bold.ttf";
import AbhayaRegular from "../../AbhayaLibre-Regular.ttf";
import AbhayaBold from "../../AbhayaLibre-Bold.ttf";
import GoodVibrations from '../../GoodVibrations Script.ttf'
import PoppinsRegular from '../../Poppins-Regular.ttf'
import QRCode from "qrcode";
import BlankCertificate from "../../img/Impact-Directors-Certificate.png";
import axios from "axios";

import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  
  Image,
  Font,
  
} from "@react-pdf/renderer";
import moment from "moment";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import JSZip from "jszip";
import  LoadingIcons  from 'react-loading-icons';

const CeritficateAllImpactDirectors = () => {
  const [isDone, setIsDone] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [generationError, setGenerationError] = useState("");
  const { eventId, delegateId } = useParams();

Font.register({
    family:'AbhayaLibreSemiBold',
    src:FontAbhaya
  });
Font.register({
    family:'RobotoBold',
    src:RobotoBold
  });
Font.register({
    family:'AbhayaRegular',
    src:AbhayaRegular
  });
Font.register({
    family:'AbhayaBold',
    src:AbhayaBold
  });
  Font.register({
    family:'GoodVibrations',
    src:GoodVibrations
  });Font.register({
    family:'PoppinsRegular',
    src:PoppinsRegular
  });
  const SIGNATURE_DIMENSIONS = {
        minWidth: 120,
        maxWidth: 130,
        minHeight: 50,
        maxHeight: 70,
        defaultWidth: 120,
        defaultHeight: 52,
      };
  const SIGNATURE_LEFT = 653;
  const SIGNER_BLOCK_WIDTH = 220;
  const SIGNER_BLOCK_CENTER_X =
    SIGNATURE_LEFT + SIGNATURE_DIMENSIONS.defaultWidth / 2;
  const styles = StyleSheet.create({
    page: {
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1
    },viewer: {
      width: 870, 
      height: 690,
    },
    bgimages: {
      height:595,
      width:842,
      position: 'absolute'
    },title:{
        top:15,
        textAlign:'center',
        fontSize:58,
        color:'white',
      fontFamily:'AbhayaLibreSemiBold'
    },participation:{
        top:15,
        textAlign:'center',
        fontSize:21,
        color:'#F3D649',
      fontFamily:'RobotoBold'
    },initialline:{
        letterSpacing:1.5,
        top:210,
        textAlign:'center',
        fontSize:16,
        color:'#000000',
      fontFamily:'AbhayaRegular'
    },showcase:{
        top:250,
        textAlign:'center',
        fontSize:12,
        color:'#000000',
      fontFamily:'PoppinsRegular',
      marginHorizontal:144
    },complete:{
        top:250,
        textAlign:'center',
        fontSize:16,
        color:'#000000',
      fontFamily:'AbhayaRegular'
    },completeDate:{
        top:422,
        left:95,
        // textAlign:'center',
        fontSize:16,
        color:'#009EDC',
      // fontFamily:'AbhayaRegular'
    },completeLocation:{
        top:250,
        textAlign:'center',
        fontSize:16,
        color:'#000000',
      fontFamily:'AbhayaRegular'
    },fullname:{
        top:385,
        textAlign:'center',
        fontSize:32,
        color:'#4c8dcb',
      // fontFamily:'RobotoBold'
    },headNameRight:{
        top:321,
        textAlign:'center',
        fontSize:16,
        color:'#4c8dcb',
      fontFamily:'AbhayaBold',
      
    },headNameLeft:{
        top:321,
        textAlign:'center',
        fontSize:16,
        color:'#4c8dcb',
      fontFamily:'AbhayaBold',
      marginLeft:18
    },headPositionRight:{
        top:318,
        textAlign:'center',
        fontSize:12,
        color:'#000000',
      fontFamily:'RobotoBold',
      marginRight:45
      
    },headPositionLeft:{
        top:318,
        textAlign:'center',
        fontSize:12,
        color:'#000000',
      fontFamily:'RobotoBold',
      marginLeft:55
    },lowerView:{
        top:140
    },
    QRImage:{
        top:490,
        left:390,
        position:'absolute',
        width:75},
    signatureImage:{
      top:467,
      left:SIGNATURE_LEFT,
      width:SIGNATURE_DIMENSIONS.defaultWidth,
      height:SIGNATURE_DIMENSIONS.defaultHeight,
      minWidth:SIGNATURE_DIMENSIONS.minWidth,
      maxWidth:SIGNATURE_DIMENSIONS.maxWidth,
      minHeight:SIGNATURE_DIMENSIONS.minHeight,
      maxHeight:SIGNATURE_DIMENSIONS.maxHeight,
      position:'absolute',
      objectFit:'contain'
    },
    signerBlock:{
      top:540,
      left:SIGNER_BLOCK_CENTER_X - SIGNER_BLOCK_WIDTH / 2,
      width:SIGNER_BLOCK_WIDTH,
      alignItems:'center',
      position:'absolute'
    },
    signerName:{
      width:'100%',
      textAlign:'center',
      fontSize:10,
      color:'#009EDC',
      fontFamily:'PoppinsRegular',
      textTransform:'uppercase'
    },
    signerDesignation:{
      width:'100%',
      marginTop:1,
      textAlign:'center',
      fontSize:9,
      color:'#000000',
      fontFamily:'RobotoBold',
      textTransform:'uppercase'
    }
    
  });

  var userEmail;
  var JSToken;
  var accessToken;
  if (localStorage.user) {
    userEmail = localStorage.user_email;
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
  }
  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  const zip = new JSZip();
  const folder = zip.folder("files");
  const generateQR = async (text) => {
    try {
      return await QRCode.toDataURL(text, {
        color: {
          dark: "#009EDC", // Blue dots
          light: "#0000", // Transparent background
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
  const getFirstDefinedValue = (source, keys) => {
    for (let index = 0; index < keys.length; index += 1) {
      const value = source?.[keys[index]];
      if (value !== undefined && value !== null && `${value}`.trim() !== "") {
        return `${value}`.trim();
      }
    }
    return "";
  };

  const blobToDataUri = (blobData) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blobData);
    });

  const fetchSignatureImage = async (signatureFileUrl) => {
    const normalizedSignatureUrl = `${signatureFileUrl || ""}`.trim();
    if (!normalizedSignatureUrl) {
      return null;
    }

    if (normalizedSignatureUrl.startsWith("data:")) {
      return normalizedSignatureUrl;
    }

    try {
      const signatureDownloadUrl =
        normalizedSignatureUrl.startsWith("http://") ||
        normalizedSignatureUrl.startsWith("https://")
          ? normalizedSignatureUrl
          : `https://dash.bestdiplomats.org/api/method/frappe.core.doctype.file.file.download_file?file_url=${encodeURIComponent(normalizedSignatureUrl)}`;

      const signatureResponse = await axios.get(signatureDownloadUrl, {
        ...config,
        responseType: "blob",
      });
      return await blobToDataUri(signatureResponse.data);
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchCertificateDetails = async () => {
    const certificateListResponse = await axios.get(
      `https://dash.bestdiplomats.org/api/resource/Certificates%20Info?filters=[["events","=","${eventId}"]]&order_by=creation desc&limit_page_length=1`,
      config
    );
    const certificateName = certificateListResponse?.data?.data?.[0]?.name;
    if (!certificateName) {
      throw new Error("Certificate information is missing for this event.");
    }

    const certificateResponse = await axios.get(
      `https://dash.bestdiplomats.org/api/resource/Certificates%20Info/${encodeURIComponent(certificateName)}`,
      config
    );
    const certificateData = certificateResponse?.data?.data || {};
    const signer = getFirstDefinedValue(certificateData, [
      "signer",
      "signer_name",
      "sender_name",
      "signed_by",
    ]);
    const designation = getFirstDefinedValue(certificateData, [
      "designation",
      "signer_designation",
      "sender_designation",
    ]);
    const signatureField = getFirstDefinedValue(certificateData, [
      "signature",
      "signer_signature",
      "sender_signature",
    ]);
    const signatureImage = await fetchSignatureImage(signatureField);

    return {
      signer,
      designation,
      signatureImage,
    };
  };

  const sleep = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  };

  const fetchEventRegisteration = async (eventPass) => {
    try {
      setGenerationError("");
      const [registrationsResponse, certificateDetails] = await Promise.all([
        axios.get(
          `https://dash.bestdiplomats.org/api/method/internal-registrations?filters=[["event","=","${eventId}"],["reg_status","!=","Terminated"]]`,
          config
        ),
        fetchCertificateDetails(),
      ]);
      const registrations = registrationsResponse?.data?.data || [];
      if (!eventPass) {
        throw new Error("Event details are missing.");
      }
      if (registrations.length === 0) {
        throw new Error("No registrations were returned for this event.");
      }

      const forLoop = async () => {
        for (let index = 0; index < registrations.length; index++) {
            
          await sleep(1000);
          setPercentage(Math.floor(((index + 1) / registrations.length) * 100));
          if (
            (
              registrations[index]?.delegate_profile.user.first_name +
              registrations[index]?.delegate_profile.user.last_name
            ).length > 25
          ) {
            var setFontSize = 38;
            var setFullNameTop = 379.2;
            var setLowerViewTop = 142;
            var setCompleteDateTop = 421.5;
          } else {
              
              var setFontSize = 44;
              var setFullNameTop = 375;
              var setLowerViewTop = 137;
              var setCompleteDateTop = 415.0;
          }

          const generateQR = async (text) => {
            try {
              return await QRCode.toDataURL(text, {
                color: {
                  dark: "#009EDC", // Blue dots
                  light: "#0000", // Transparent background
                },
              });
            } catch (err) {
              console.error(err);
            }
          };

            
          await generatePdfDocument(
            <Document>
              <Page size={[842, 595]}>
                <Image
                  src={BlankCertificate}
                  style={styles.bgimages}
                ></Image>
                
                  <Text
                    style={{
                      top: setFullNameTop,
                      fontSize: setFontSize,
                      textAlign: "center",
                      color: "#009EDC",
                      fontFamily: "AbhayaRegular",
                      textTransform: "capitalize",
                    }}
                  >
                    {""}
                    {"" +
                      registrations[
                        index
                      ]?.delegate_profile.user.first_name?.replace(/\n/g, "")?.toLowerCase()+
                      " " +
                      registrations[
                        index
                      ]?.delegate_profile.user.last_name?.replace(/\n/g, "")?.toLowerCase()}
                  </Text>
                  <View style={{ top: setLowerViewTop }}>
                    <Text style={styles.showcase}>
                    In recognition of your visionary thinking, strategic planning and innovative problem solving at Impact Directors {eventPass?.country}.</Text>

                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >

                    </View>

                  

                  
                  </View>
                  <Text style={{ top:setCompleteDateTop,
                       left:80,
                       fontSize:13,
                       textAlign:"start",
                       color:'#000000',
                     fontFamily:'PoppinsRegular'}}>{moment(eventPass?.end_date).format("Do MMMM YYYY")}</Text>
                  {certificateDetails?.signatureImage && (
                    <Image source={certificateDetails.signatureImage} style={styles.signatureImage}></Image>
                  )}
                  {(certificateDetails?.signer || certificateDetails?.designation) && (
                    <View style={styles.signerBlock}>
                      {certificateDetails?.signer && (
                        <Text style={styles.signerName}>{certificateDetails.signer}</Text>
                      )}
                      {certificateDetails?.designation && (
                        <Text style={styles.signerDesignation}>{certificateDetails.designation}</Text>
                      )}
                    </View>
                  )}
                <Image
                  source={generateQR(
                    `https://verify.impactdirectors.org/verify/${registrations[index]?.delegate_profile.name}-${eventId}-${registrations[index]?.name}`
                  )}
                  style={styles.QRImage}
                ></Image>
              </Page>
            </Document>,
            registrations[index]?.delegate_profile.user.first_name,
            registrations[index]?.delegate_profile.user.last_name
          );
        }
      };

      await forLoop();
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "All Certificates");
      setIsDone(true);
    } catch (e) {
      console.log(e);
      setGenerationError(
        e?.message ||
          "Certificate generation stopped because required API data is missing."
      );
    }
  };
  const generatePdfDocument = async (documentData, firstname, lastname) => {
    const blob = await pdf(documentData).toBlob();
    folder.file(firstname + " " + lastname + ".pdf", blob);

    // saveAs(blob,  firstname+" "+lastname);
  };

  //   Event Details
  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await axios.get(
          "https://dash.bestdiplomats.org/api/resource/Events/" + eventId
        );
        const eventData = response?.data?.data;
        if (!eventData) {
          throw new Error("Event details are missing.");
        }
        await fetchEventRegisteration(eventData);
      } catch (e) {
        console.log(e);
        setGenerationError(
          e?.message ||
            "Certificate generation stopped because required API data is missing."
        );
      }
    };
    fetchEventData();
  }, []);

  return (
    <div>
      {generationError ? (
        <span className="group ml-auto mr-auto relative flex w-96 justify-center rounded-md border border-transparent bg-red-600 my-4 py-2 px-4 text-sm font-medium text-white focus:outline-none">
          {generationError}
        </span>
      ) : null}
      {isDone ? (
        <span className="group ml-auto mr-auto relative flex w-64 justify-center rounded-md border border-transparent bg-green-700 my-4  py-2 px-4 text-sm font-medium text-white  focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-offset-2">
          Done Downloading
        </span>
      ) : !generationError ? (
        <>
        <span className="group ml-auto mr-auto relative flex w-64 justify-center rounded-md border border-transparent bg-red-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        <LoadingIcons.SpinningCircles className="w-7 h-7"/>
        
        </span>
        <div className="flex justify-center">
        <span>This may take a few minutes. Your file will be download automatically.</span>
        </div>
        </>
      ) : null}
      <div className="flex justify-center mt-2">
      <div className="w-96 bg-gray-200 rounded-full dark:bg-gray-700 ">
    <div className="bg-red-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full" style={{'width':percentage+"%"}}> {percentage}%</div>
  </div>
  </div>
    </div>
  );
};

export default CeritficateAllImpactDirectors
